const init = () => {
    a11yFixes();
};
const a11yFixes = () => {
    const links = document.querySelectorAll('a[target="_blank"]:not([aria-label*="new window"])');
    if (links) {
        links.forEach((link, ind) => {
            link.setAttribute('aria-label', `Open ${encodeURIComponent(link.textContent.trim())} in new window`);
        });
    }
};

window.onload = () => {
    init();
};

window.getSavedDesigns = () => {
    return Object.entries(localStorage)
        .filter(([key]) => key.startsWith("customDesign--"))
        .map(([key, json]) => JSON.parse(json))
        .flatMap(({
                product,
                design_product
            }) =>
            design_product.map(({
                created_at,
                designProduct,
                url
            }) => ({
                productId: product,
                createdAt: created_at,
                design: designProduct,
                url,
            }))
        )
        .map(item => ({
            id: item.design.design.id,
            title: item.design.design.design.name,
            price: `$${item.design.design.design.price / 100}`,
            image: item.design.design.image,
            url: item.url,
            sku: item.design.design.design.sku
        }));
};